import React, { useContext, useEffect, useRef, useState } from "react";
import "../styles/searchConsultants.css";
import LoadingIcon from "../images/Loading_icon.gif";
import { Link, useParams } from "react-router-dom";
import SimilarProfileRow from "../components/SimilarProfilesForList/SimilarProfileRow";
import ProjectTitle from "../components/ListDetails/ProjectTitle";
import { UrlContext } from "../contexts/UrlContext";

export default function SimilarProfilesForList() {
  const [searchExpand, setSearchExpand] = useState(false);
  const [project, setProject] = useState({});
  const [data, setData] = useState(null);
  const [total, setTotal] = useState(0);
  const [backupData, setBackupData] = useState(null);
  const [filterName, setFilterName] = useState("");
  const [filterLocation, setFilterLocation] = useState("");
  const nameInputRef = useRef(null);
  const locationInputRef = useRef(null);
  const { API_URL } = useContext(UrlContext);
  const proj_id = useParams().proj_id;
  const exp_id = useParams().exp_id;
  const keyword = useParams().keyword;

  useEffect(() => {
    const url = `${API_URL}list-title/` + proj_id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setProject(data.project);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    let url = `${API_URL}get-ai-suggestion/${proj_id}/${keyword}`;
    if (exp_id) {
      url = `${API_URL}get-similar-profiles-for-list/${proj_id}/${exp_id}`;
    }
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.experts);
        setBackupData(data.experts);
        setTotal(data.experts.length);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [proj_id, exp_id]);

  useEffect(() => {
    if (exp_id) {
      document.title = "Similar Profiles";
    } else if (keyword) {
      document.title = "AI Suggested Profiles";
    }
  }, []);

  useEffect(() => {
    if (filterName || filterLocation) {
      const filteredData = backupData.filter((item) => {
        const name = item.name.toLowerCase();
        const location = item.location.toLowerCase();
        return (
          name.includes(filterName.toLowerCase()) &&
          location.includes(filterLocation.toLowerCase())
        );
      });
      setData(filteredData);
    } else {
      setData(backupData);
    }
  }, [filterName, filterLocation, backupData]);

  return (
    <>
      <ProjectTitle project={project} />
      <div className="container-div">
        <h1 className="search-con-totalHeading">
          {total > 1
            ? `${total}${exp_id ? " similar" : ""} profiles are found`
            : total === 1
            ? `${total}${exp_id ? " similar" : ""} profile is found`
            : `. . . .`}
        </h1>
      </div>
      <div className="search-con-table container-div">
        <ul className="search-con-filters list-unstyled form-inline">
          <li className="search-con-name-filter">
            <span className="no-select">Search Name</span>
            <div className="search-con-search-box">
              <input
                className={
                  searchExpand
                    ? "search-con-search-input search-con-filter-expand"
                    : "search-con-search-input"
                }
                placeholder="Search Name"
                onChange={(e) => setFilterName(e.target.value)}
                value={filterName}
                ref={nameInputRef}
              />
              <i
                className="search-con-search-icon fa-solid fa-magnifying-glass"
                onClick={(e) => {
                  setSearchExpand(!searchExpand);
                  nameInputRef.current.focus();
                }}
              />
            </div>
          </li>
          <li className="search-con-location-filter">
            <span className="no-select">Location</span>
            <div className="search-con-searchLoc-box">
              <input
                className={
                  searchExpand
                    ? "search-con-searchLoc-input search-con-location-expand"
                    : "search-con-searchLoc-input"
                }
                placeholder="Location"
                onChange={(e) => setFilterLocation(e.target.value)}
                value={filterLocation}
                ref={locationInputRef}
              />
              <i
                className="search-con-searchLoc-icon fa-solid fa-magnifying-glass"
                onClick={(e) => {
                  setSearchExpand(!searchExpand);
                  locationInputRef.current.focus();
                }}
              />
            </div>
          </li>
        </ul>
        {data ? (
          <>
            {data?.map((consultant, index) => {
              return (
                <SimilarProfileRow
                  key={index}
                  consultant={consultant}
                  proj_id={proj_id}
                />
              );
            })}
            {data.length === 0 && (
              <div className="search-con-table-row">
                <div className="search-con-row-top" style={{ height: "45px" }}>
                  <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                    No consultant found
                  </h5>
                </div>
                <div className="search-con-row-bottom"></div>
              </div>
            )}

            <div className="div-backto-project">
              <Link to={`/app/ListDetails/${proj_id}`}>
                <button className="btn">
                  <a>Back to Project </a>
                  <i className="fa-solid fa-arrow-right"></i>
                </button>
              </Link>
            </div>
          </>
        ) : (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <img
              src={LoadingIcon}
              alt="Loading..."
              style={{ height: "50px" }}
            />
          </div>
        )}
      </div>
    </>
  );
}
